import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import NavBar from '../components/NavBar'
import AuthMiddleware from './../modules/auth/middleware'
import ModalChangedUnit from './Modal/ChangedUnit'

const mapStateToProps = ({ auth, units }) => ({
  user: auth.authUser,
  role: auth.userRole.role,
  unit: units.unit.item
})

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    logout: () => AuthMiddleware.logout()
  }, dispatch)
}

class NavBarContainer extends Component {
  state = {
    isMenuOpen: false,
    isOpenModal: false
  }
  componentDidMount () {
    document.body.addEventListener('click', this.handleBodyClick)
  }
  componentWillUnmount () {
    document.body.removeEventListener('click', this.handleBodyClick)
  }

  toggleProfileDropdown = (e) => {
    e.preventDefault()
    this.setState({
      isMenuOpen: !this.state.isMenuOpen
    })
  }
  handleBodyClick = (e) => {
    if (e.target.parentNode === this.buttonOpenDropDown || e.target === this.buttonOpenDropDown) {
      return false
    }
    this.setState({
      isMenuOpen: false
    })
  }
  handleStopPropagation = (e) => {
    this.setState({
      isMenuOpen: true
    })
  }
  handleClickOpenModal = () => {
    this.setState({ isOpenModal: true })
  }
  handleCloseModal = () => {
    this.setState({ isOpenModal: false })
  }
  render () {
    const { logout, user, role } = this.props
    const { isMenuOpen } = this.state
    return (
      <div>
        <NavBar
          container
          unit={this.props.unit}
          user={user}
          isMenuOpen={isMenuOpen}
          buttonOpenDropDownRef={el => { this.buttonOpenDropDown = el }}
          logout={logout}
          role={role}
          toggleProfileDropdown={this.toggleProfileDropdown}
          handleStopPropagation={this.handleStopPropagation}
          hasProfileImage={false}
          handleClickOpenModal={this.handleClickOpenModal}
        />
        <ModalChangedUnit
          isOpenModal={this.state.isOpenModal}
          handleCloseModal={this.handleCloseModal}
        />
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(NavBarContainer)



// WEBPACK FOOTER //
// ./src/containers/NavBarContainer.js